<script lang="ts">
  // UI components
  import { Input } from '$lib/components/ui/input';
  import { Label } from '$lib/components/ui/label/index.js';
  import { Switch } from '$lib/components/ui/switch/index.js';
  import * as Table from '$lib/components/ui/table/index.js';

  import { Circle } from '@lucide/svelte';

  // RoastLog
  import {
    sanFranciscanSettings,
    selectedRoaster,
    selectedDeviceType
  } from '$lib/PersistedState.svelte';
  import { getDeviceLabels } from '$lib/devices/registry';

  const deviceLabels = getDeviceLabels(selectedDeviceType.value);
</script>

<div class="grid grid-cols-2 gap-2">
  <div>
    <Label>Host</Label>
    <Input
      type="text"
      placeholder="192.168.1.100"
      class="max-w-xs"
      bind:value={sanFranciscanSettings.current.host}
    />
  </div>

  <div>
    <Label>Starting Register</Label>
    <Input
      type="number"
      placeholder="360"
      class="max-w-xs"
      bind:value={sanFranciscanSettings.current.register}
    />
  </div>
</div>
